import React from 'react';

export const LoadingState = ({ message = 'Loading...', fullScreen = false }) => {
  const containerClass = fullScreen
    ? 'flex items-center justify-center h-screen'
    : 'flex items-center justify-center py-12';

  return (
    <div className={containerClass} data-testid="loading-state">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">{message}</p>
      </div>
    </div>
  );
};

export default LoadingState;
